// A single work entry: the whole row is the link.
export function ExperienceItem({ logoSrc, title, company, link, description, term, index, onMouseEnter, onMouseLeave }) {
  return (
    <a
      className="row"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ '--i': index }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <img className="row-logo" src={logoSrc} alt="" loading="lazy" />
      <span className="row-body">
        <span className="row-title">
          {title} <span className="at">@</span> {company}
          <span className="arrow" aria-hidden="true">↗</span>
        </span>
        <span className="row-desc">{description}</span>
      </span>
      {term && <span className="row-term">{term}</span>}
    </a>
  );
}

// A project entry: links live inline next to the title instead of on the row.
export function ProjectItem({ title, description, links, badge, index, onMouseEnter, onMouseLeave }) {
  return (
    <div className="row" style={{ '--i': index }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <span className="row-body">
        <span className="project-head">
          <span className="row-title">{title}</span>
          {badge && <span className="badge">{badge}</span>}
          <span className="project-links">
            {links.map(({ label, href }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            ))}
          </span>
        </span>
        <span className="row-desc">{description}</span>
      </span>
    </div>
  );
}
